import React from "react";
import { Header } from "./header/Header";
import { Footer } from "./footer/Footer";
import { Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const Layout = () => {
   const location = useLocation();
   const routes = useSelector((state) => state.gallery.routes);

  const current = routes?.[location.pathname] || {};
  const headerName = current.headerName || "Page";
  const bgImage = current.bgImage || "/assets/image/backgrounds/default.svg"; 
  return (
    <>
      <header>
        <Header headerName={headerName} bgImage={bgImage}  />
      </header>
      <main>
        <Outlet />
      </main>
      <footer>
       <Footer/>
      </footer>
    </>
  );
};
